import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17;

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import { LocationServiceStatus } from "../utils";
import Base from "./Base";
import { computed, observable, makeObservable, runInAction, action, reaction } from "mobx";
import DPServices, { UserTypes } from "@dp/services";
import LoginModal from "./models/LoginModal";
import AnalyticsModel from "./models/AnalyticsModel";
import Errors, { ERROR_STRINGS } from "./Errors";
import { SignUpModel, UserProfileModel } from "./models";
import { handle, PlatformType, PushNotificationAuthorizationStatus, CapabilityPermissionStatus, convertFromString, getEnvProps } from "@dp/common";
import gt from "lodash/gt";
import isEqual from "lodash/isEqual";
import toInteger from "lodash/toInteger";
var SECURE_STORE_CRDS_KEY = "APP_CRDS";
var User = (_class = /*#__PURE__*/function (_Base) {
  _inherits(User, _Base);

  var _super = _createSuper(User); // public joinWaitlistModel: JoinWaitlistModel;


  function User(rootStore) {
    var _this;

    _classCallCheck(this, User);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "sessionDetails", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "userProfile", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "profileResponse", _descriptor3, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "loginModal", void 0);

    _defineProperty(_assertThisInitialized(_this), "analyticsModel", void 0);

    _defineProperty(_assertThisInitialized(_this), "signUpModel", void 0);

    _defineProperty(_assertThisInitialized(_this), "userProfileModel", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "savedCreds", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "isAuthenticated", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "foreGroundLocationPermissions", _descriptor6, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "backGroundLocationPermissions", _descriptor7, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "deviceAuth", _descriptor8, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "currentUserLocation", _descriptor9, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_promptForLocationPermissions", _descriptor10, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "pushNotificationAuthorizationStatus", _descriptor11, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "photoLibraryPermissionStatus", _descriptor12, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_promptForPhotoLibraryPermissions", _descriptor13, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_showHomeScreenAlert", _descriptor14, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_restaurantIdToBeSavedInUserProfile", _descriptor15, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isHomeScreenAlertClosed", _descriptor16, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isOrderSummaryOpen", _descriptor17, _assertThisInitialized(_this));

    makeObservable(_assertThisInitialized(_this));
    _this.loginModal = new LoginModal();
    _this.signUpModel = new SignUpModel();
    _this.userProfileModel = new UserProfileModel(); // this.joinWaitlistModel = new JoinWaitlistModel();

    _this.rootStore = rootStore;
    _this.analyticsModel = new AnalyticsModel(rootStore.platformUtil);
    return _this;
  }

  _createClass(User, [{
    key: "setupReactions",
    value: function setupReactions() {
      var _this2 = this;

      reaction(function () {
        var _this2$loginModal;

        return {
          disableAutoLogin: (_this2$loginModal = _this2.loginModal) === null || _this2$loginModal === void 0 ? void 0 : _this2$loginModal.disableAutoLogin
        };
      }, function (data) {
        _this2.rootStore.platformUtil.saveInSecureStore("DISABLE_AUTO_LOGIN", data.disableAutoLogin.toString());
      }); // reaction to update app attributes in analytics model

      reaction(function () {
        return {
          appAttributes: _this2.rootStore.common.appAttributes
        };
      }, function (data) {
        if (data !== null && data !== void 0 && data.appAttributes) {
          _this2.analyticsModel.setAppAttributes(data === null || data === void 0 ? void 0 : data.appAttributes);
        }
      }); // reaction takes care when the session-api gives transient as true, but is not handled, and user-profile is present, thus enforcing for the new-session.

      reaction(function () {
        return {
          isLoggedIn: _this2.isLoggedIn
        };
      }, function (data) {
        if (!data.isLoggedIn && _this2.userProfile) {
          _this2.rootStore.appMessages.showError("Session Expired", "Your session has expired due to an extended period of inactivity.", null, {
            undismissible: true,
            okBtnText: "Ok",
            okBtnOnClick: function okBtnOnClick() {
              _this2.rootStore.reloadApp();
            }
          });
        }
      });
      return;
    }
  }, {
    key: "fetchSavedCredentials",
    value: function () {
      var _fetchSavedCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        var savedCreds;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.savedCreds === null || this.savedCreds === undefined)) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return this.getSavedCredentials();

              case 3:
                savedCreds = _context.sent;

                if (savedCreds) {
                  runInAction(function () {
                    _this3.savedCreds = savedCreds;
                  });
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchSavedCredentials() {
        return _fetchSavedCredentials.apply(this, arguments);
      }

      return fetchSavedCredentials;
    }()
  }, {
    key: "dissmissPromptForLocationPermissions",
    value: function () {
      var _dissmissPromptForLocationPermissions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var forEver,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                forEver = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;

                if (!forEver) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 4;
                return this.rootStore.platformUtil.saveInLocalStorage("DISMISS_LOCATION_PERMISSIONS_PROMPT", "true");

              case 4:
                _context2.next = 8;
                break;

              case 6:
                _context2.next = 8;
                return this.rootStore.platformUtil.saveInSessionStorage("DISMISS_LOCATION_PERMISSIONS_PROMPT", "true");

              case 8:
                this.promptForLocationPermissions = false;

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function dissmissPromptForLocationPermissions() {
        return _dissmissPromptForLocationPermissions.apply(this, arguments);
      }

      return dissmissPromptForLocationPermissions;
    }()
  }, {
    key: "dismissPromptForPhotoLibraryPermissions",
    value: function () {
      var _dismissPromptForPhotoLibraryPermissions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var forEver,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                forEver = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : false;

                if (!forEver) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 4;
                return this.rootStore.platformUtil.saveInLocalStorage("DISMISS_PHOTO_LIBRARY_PERMISSIONS_PROMPT", "true");

              case 4:
                _context3.next = 8;
                break;

              case 6:
                _context3.next = 8;
                return this.rootStore.platformUtil.saveInSessionStorage("DISMISS_PHOTO_LIBRARY_PERMISSIONS_PROMPT", "true");

              case 8:
                this.promptForPhotoLibraryPermissions = false;

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function dismissPromptForPhotoLibraryPermissions() {
        return _dismissPromptForPhotoLibraryPermissions.apply(this, arguments);
      }

      return dismissPromptForPhotoLibraryPermissions;
    }()
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _sessionDetails$succe,
            _sessionDetails$succe2,
            _this4 = this;

        var _getEnvProps, BYPASS_BIOMETRIC_AUTH_FOR_SAVED_CREDS, sessionDetails, isTransient, userProfile;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return handle(this.rootStore.platformUtil.hydrateUsingLocalStorage("LOGIN_INFO", this.loginModal));

              case 2:
                _context4.next = 4;
                return this.rootStore.platformUtil.getFromSecureStore("DISABLE_AUTO_LOGIN");

              case 4:
                _context4.t0 = _context4.sent;
                this.loginModal.disableAutoLogin = _context4.t0 === "true";
                _getEnvProps = getEnvProps(), BYPASS_BIOMETRIC_AUTH_FOR_SAVED_CREDS = _getEnvProps.BYPASS_BIOMETRIC_AUTH_FOR_SAVED_CREDS;

                if (!(BYPASS_BIOMETRIC_AUTH_FOR_SAVED_CREDS || BYPASS_BIOMETRIC_AUTH_FOR_SAVED_CREDS === "true")) {
                  _context4.next = 10;
                  break;
                }

                _context4.next = 10;
                return this.attemptLoginWithSavedCredentials();

              case 10:
                _context4.next = 12;
                return DPServices.User.getSessionDetails(this.rootStore.platformUtil.getLocationPathName(), null, null, false);

              case 12:
                sessionDetails = _context4.sent;
                isTransient = sessionDetails === null || sessionDetails === void 0 ? void 0 : (_sessionDetails$succe = sessionDetails.successResponse) === null || _sessionDetails$succe === void 0 ? void 0 : (_sessionDetails$succe2 = _sessionDetails$succe.profile) === null || _sessionDetails$succe2 === void 0 ? void 0 : _sessionDetails$succe2["transient"];

                if (isTransient) {
                  _context4.next = 21;
                  break;
                }

                _context4.next = 17;
                return this.getCurrentUserProfile(true);

              case 17:
                userProfile = _context4.sent;
                runInAction(function () {
                  _this4.sessionDetails = sessionDetails;
                  _this4.userProfile = userProfile;
                  _this4.isAuthenticated = true;
                });
                _context4.next = 22;
                break;

              case 21:
                runInAction(function () {
                  _this4.sessionDetails = sessionDetails;
                });

              case 22:
                this.analyticsModel.setSessionDetails(sessionDetails); // Making this call only on APP. On web this will be on Demand.

                if (!(this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP)) {
                  _context4.next = 26;
                  break;
                }

                _context4.next = 26;
                return this.determineDeviceCapabilities();

              case 26:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "getCurrentUserProfile",
    value: function () {
      var _getCurrentUserProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var cache,
            userProfile,
            cachedUserProfile,
            _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                cache = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : false;
                userProfile = null;

                if (!cache) {
                  _context5.next = 7;
                  break;
                }

                _context5.next = 5;
                return this.rootStore.platformUtil.getFromLocalStorage("USER_PROFILE");

              case 5:
                cachedUserProfile = _context5.sent;

                if (cachedUserProfile) {
                  userProfile = JSON.parse(cachedUserProfile);
                }

              case 7:
                if (!userProfile) {
                  _context5.next = 11;
                  break;
                }

                return _context5.abrupt("return", userProfile);

              case 11:
                _context5.next = 13;
                return DPServices.User.getCurrentUserProfile();

              case 13:
                userProfile = _context5.sent;
                this.cacheUserProfile(userProfile);
                return _context5.abrupt("return", userProfile);

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getCurrentUserProfile() {
        return _getCurrentUserProfile.apply(this, arguments);
      }

      return getCurrentUserProfile;
    }()
  }, {
    key: "refreshCurrentUserProfile",
    value: function () {
      var _refreshCurrentUserProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this5 = this;

        var userProfile;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.getCurrentUserProfile();

              case 2:
                userProfile = _context6.sent;
                runInAction(function () {
                  _this5.userProfile = userProfile;
                });

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function refreshCurrentUserProfile() {
        return _refreshCurrentUserProfile.apply(this, arguments);
      }

      return refreshCurrentUserProfile;
    }()
  }, {
    key: "cacheUserProfile",
    value: function () {
      var _cacheUserProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(profile) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", this.rootStore.platformUtil.saveInLocalStorage("USER_PROFILE", JSON.stringify(profile)));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function cacheUserProfile(_x) {
        return _cacheUserProfile.apply(this, arguments);
      }

      return cacheUserProfile;
    }()
  }, {
    key: "refreshSessionDetails",
    value: function () {
      var _refreshSessionDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var _this6 = this;

        var sessionDetails;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return DPServices.User.getSessionDetails(this.rootStore.platformUtil.getLocationPathName(), null, null, false);

              case 2:
                sessionDetails = _context8.sent;
                runInAction(function () {
                  _this6.sessionDetails = sessionDetails;
                });
                this.analyticsModel.setSessionDetails(sessionDetails);

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function refreshSessionDetails() {
        return _refreshSessionDetails.apply(this, arguments);
      }

      return refreshSessionDetails;
    }()
  }, {
    key: "determineLocationPermissionsPromptState",
    value: function () {
      var _determineLocationPermissionsPromptState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var foreGroundLocationPermissions, localLevel, sessionLevel;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                foreGroundLocationPermissions = this.foregroundLocationPermissionGranted;

                if (!foreGroundLocationPermissions) {
                  _context9.next = 9;
                  break;
                }

                _context9.next = 4;
                return this.rootStore.platformUtil.removeFromLocalStorage("DISMISS_LOCATION_PERMISSIONS_PROMPT");

              case 4:
                _context9.next = 6;
                return this.rootStore.platformUtil.removeFromSessionStorage("DISMISS_LOCATION_PERMISSIONS_PROMPT");

              case 6:
                this.promptForLocationPermissions = false;
                _context9.next = 16;
                break;

              case 9:
                _context9.next = 11;
                return this.rootStore.platformUtil.getFromLocalStorage("DISMISS_LOCATION_PERMISSIONS_PROMPT");

              case 11:
                localLevel = _context9.sent;
                _context9.next = 14;
                return this.rootStore.platformUtil.getFromSessionStorage("DISMISS_LOCATION_PERMISSIONS_PROMPT");

              case 14:
                sessionLevel = _context9.sent;

                if (sessionLevel === "true") {
                  this.promptForLocationPermissions = false;
                } else {
                  if (localLevel === "true") {
                    this.promptForLocationPermissions = false;
                  } else {
                    this.promptForLocationPermissions = true;
                  }
                }

              case 16:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function determineLocationPermissionsPromptState() {
        return _determineLocationPermissionsPromptState.apply(this, arguments);
      }

      return determineLocationPermissionsPromptState;
    }()
  }, {
    key: "determinePhotoLibraryPermissionsPromptState",
    value: function () {
      var _determinePhotoLibraryPermissionsPromptState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var _this7 = this;

        var newPermission, oldPermissions;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.rootStore.platformUtil.getPhotoLibraryPermissions();

              case 2:
                newPermission = _context10.sent;
                oldPermissions = this.photoLibraryPermissionStatus;

                if (!oldPermissions) {
                  _context10.next = 22;
                  break;
                }

                if (!(oldPermissions === CapabilityPermissionStatus.DENIED || oldPermissions === CapabilityPermissionStatus.BLOCKED)) {
                  _context10.next = 14;
                  break;
                }

                if (!(newPermission === CapabilityPermissionStatus.GRANTED || newPermission === CapabilityPermissionStatus.LIMITED)) {
                  _context10.next = 10;
                  break;
                }

                this.rootStore.platformUtil.requestPhotoLibraryPermission();
                _context10.next = 12;
                break;

              case 10:
                _context10.next = 12;
                return this.handlePhotoLibraryPermissionsDenied();

              case 12:
                _context10.next = 20;
                break;

              case 14:
                if (!(newPermission === CapabilityPermissionStatus.DENIED)) {
                  _context10.next = 17;
                  break;
                }

                _context10.next = 17;
                return this.handlePhotoLibraryPermissionsDenied();

              case 17:
                if (!(newPermission === CapabilityPermissionStatus.GRANTED)) {
                  _context10.next = 20;
                  break;
                }

                _context10.next = 20;
                return this.handlePhotoLibraryPermissionAuthorized();

              case 20:
                _context10.next = 34;
                break;

              case 22:
                if (!(newPermission === CapabilityPermissionStatus.UNAVAILABLE)) {
                  _context10.next = 27;
                  break;
                }

                _context10.next = 25;
                return this.dismissPromptForPhotoLibraryPermissions(true);

              case 25:
                _context10.next = 34;
                break;

              case 27:
                if (!(newPermission === CapabilityPermissionStatus.GRANTED || newPermission === CapabilityPermissionStatus.LIMITED)) {
                  _context10.next = 32;
                  break;
                }

                _context10.next = 30;
                return this.handlePhotoLibraryPermissionAuthorized();

              case 30:
                _context10.next = 34;
                break;

              case 32:
                _context10.next = 34;
                return this.handlePhotoLibraryPermissionsDenied();

              case 34:
                runInAction(function () {
                  _this7.photoLibraryPermissionStatus = newPermission;
                });

              case 35:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function determinePhotoLibraryPermissionsPromptState() {
        return _determinePhotoLibraryPermissionsPromptState.apply(this, arguments);
      }

      return determinePhotoLibraryPermissionsPromptState;
    }()
  }, {
    key: "handlePhotoLibraryPermissionsDenied",
    value: function () {
      var _handlePhotoLibraryPermissionsDenied = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var localLevel, sessionLevel;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.rootStore.platformUtil.getFromLocalStorage("DISMISS_PHOTO_LIBRARY_PERMISSIONS_PROMPT");

              case 2:
                localLevel = _context11.sent;
                _context11.next = 5;
                return this.rootStore.platformUtil.getFromSessionStorage("DISMISS_PHOTO_LIBRARY_PERMISSIONS_PROMPT");

              case 5:
                sessionLevel = _context11.sent;

                if (sessionLevel === "true") {
                  this.promptForPhotoLibraryPermissions = false;
                } else {
                  if (localLevel === "true") {
                    this.promptForPhotoLibraryPermissions = false;
                  } else {
                    this.promptForPhotoLibraryPermissions = true;
                  }
                }

              case 7:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function handlePhotoLibraryPermissionsDenied() {
        return _handlePhotoLibraryPermissionsDenied.apply(this, arguments);
      }

      return handlePhotoLibraryPermissionsDenied;
    }()
  }, {
    key: "handlePhotoLibraryPermissionAuthorized",
    value: function () {
      var _handlePhotoLibraryPermissionAuthorized = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.rootStore.platformUtil.removeFromLocalStorage("DISMISS_PHOTO_LIBRARY_PERMISSIONS_PROMPT");

              case 2:
                _context12.next = 4;
                return this.rootStore.platformUtil.removeFromSessionStorage("DISMISS_PHOTO_LIBRARY_PERMISSIONS_PROMPT");

              case 4:
                this.promptForPhotoLibraryPermissions = false;

              case 5:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function handlePhotoLibraryPermissionAuthorized() {
        return _handlePhotoLibraryPermissionAuthorized.apply(this, arguments);
      }

      return handlePhotoLibraryPermissionAuthorized;
    }()
  }, {
    key: "processPushNotificationsPermissions",
    value: function () {
      var _processPushNotificationsPermissions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(pushNotificationPermissions, isFreshInstall) {
        var _this8 = this;

        var token, currSavedToken, permissions;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (!(pushNotificationPermissions === PushNotificationAuthorizationStatus.AUTHORIZED)) {
                  _context13.next = 11;
                  break;
                }

                runInAction(function () {
                  _this8.pushNotificationAuthorizationStatus = pushNotificationPermissions;
                });
                _context13.next = 4;
                return this.rootStore.platformUtil.registerForPushNotifications();

              case 4:
                token = _context13.sent;
                _context13.next = 7;
                return this.rootStore.platformUtil.getFromLocalStorage("PUSH_NOTIFICATIONS_TOKEN");

              case 7:
                currSavedToken = _context13.sent;

                if (!currSavedToken || currSavedToken !== token) {
                  this.rootStore.platformUtil.saveInLocalStorage("PUSH_NOTIFICATIONS_TOKEN", token.toString());
                }

                _context13.next = 26;
                break;

              case 11:
                if (!(pushNotificationPermissions === PushNotificationAuthorizationStatus.NOT_DETERMINED || pushNotificationPermissions === PushNotificationAuthorizationStatus.DENIED && isFreshInstall)) {
                  _context13.next = 19;
                  break;
                }

                _context13.next = 14;
                return this.rootStore.platformUtil.requestPushNotificationsPermission();

              case 14:
                permissions = _context13.sent;
                _context13.next = 17;
                return this.processPushNotificationsPermissions(permissions, false);

              case 17:
                _context13.next = 26;
                break;

              case 19:
                if (!(pushNotificationPermissions === PushNotificationAuthorizationStatus.DENIED || pushNotificationPermissions === PushNotificationAuthorizationStatus.PROVISIONAL)) {
                  _context13.next = 25;
                  break;
                }

                runInAction(function () {
                  _this8.pushNotificationAuthorizationStatus = pushNotificationPermissions;
                });
                _context13.next = 23;
                return this.rootStore.platformUtil.removeFromLocalStorage("PUSH_NOTIFICATIONS_TOKEN");

              case 23:
                _context13.next = 26;
                break;

              case 25:
                runInAction(function () {
                  _this8.pushNotificationAuthorizationStatus = pushNotificationPermissions;
                });

              case 26:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function processPushNotificationsPermissions(_x2, _x3) {
        return _processPushNotificationsPermissions.apply(this, arguments);
      }

      return processPushNotificationsPermissions;
    }()
  }, {
    key: "determinePushNotificationsPermissionsPromptState",
    value: function () {
      var _determinePushNotificationsPermissionsPromptState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var isFreshInstall, pushNotificationPermissions;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.rootStore.platformUtil.isFreshInstall();

              case 2:
                isFreshInstall = _context14.sent;
                _context14.next = 5;
                return this.rootStore.platformUtil.getPushNotificationsPermissions();

              case 5:
                pushNotificationPermissions = _context14.sent;
                _context14.next = 8;
                return this.processPushNotificationsPermissions(pushNotificationPermissions, isFreshInstall);

              case 8:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function determinePushNotificationsPermissionsPromptState() {
        return _determinePushNotificationsPermissionsPromptState.apply(this, arguments);
      }

      return determinePushNotificationsPermissionsPromptState;
    }()
  }, {
    key: "determineForegroundLocationPermissionsAndCurrentPosition",
    value: function () {
      var _determineForegroundLocationPermissionsAndCurrentPosition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        var foreGroundLocationPermissions, _foreGroundLocationPermissions, position;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.rootStore.platformUtil.getForegroundLocationPermissions();

              case 2:
                foreGroundLocationPermissions = _context15.sent;

                if (!(foreGroundLocationPermissions.status === "undetermined")) {
                  _context15.next = 12;
                  break;
                }

                _context15.next = 6;
                return this.rootStore.platformUtil.getCurrentGeoCoords(false);

              case 6:
                _context15.next = 8;
                return this.rootStore.platformUtil.getForegroundLocationPermissions();

              case 8:
                _foreGroundLocationPermissions = _context15.sent;
                return _context15.abrupt("return", [_foreGroundLocationPermissions, null]);

              case 12:
                if (!foreGroundLocationPermissions.granted) {
                  _context15.next = 19;
                  break;
                }

                _context15.next = 15;
                return this.rootStore.platformUtil.getCurrentGeoCoords(false);

              case 15:
                position = _context15.sent;
                return _context15.abrupt("return", [foreGroundLocationPermissions, position]);

              case 19:
                return _context15.abrupt("return", [foreGroundLocationPermissions, null]);

              case 20:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function determineForegroundLocationPermissionsAndCurrentPosition() {
        return _determineForegroundLocationPermissionsAndCurrentPosition.apply(this, arguments);
      }

      return determineForegroundLocationPermissionsAndCurrentPosition;
    }()
  }, {
    key: "requestBackgroundLocationPermissions",
    value: function () {
      var _requestBackgroundLocationPermissions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(title, message) {
        var _this9 = this;

        var backGroundLocationPermissions, resultPermissions;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.rootStore.platformUtil.getBackgroundLocationPermissions();

              case 2:
                backGroundLocationPermissions = _context16.sent;

                if (!(backGroundLocationPermissions.granted || backGroundLocationPermissions.canAskAgain || backGroundLocationPermissions.status === "undetermined")) {
                  _context16.next = 10;
                  break;
                }

                _context16.next = 6;
                return this.rootStore.platformUtil.requestBackgroundLocationPermission(title, message);

              case 6:
                resultPermissions = _context16.sent;
                runInAction(function () {
                  _this9.backGroundLocationPermissions = resultPermissions;
                });
                _context16.next = 11;
                break;

              case 10:
                runInAction(function () {
                  _this9.backGroundLocationPermissions = backGroundLocationPermissions;
                });

              case 11:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function requestBackgroundLocationPermissions(_x4, _x5) {
        return _requestBackgroundLocationPermissions.apply(this, arguments);
      }

      return requestBackgroundLocationPermissions;
    }()
  }, {
    key: "determineDeviceCapabilities",
    value: function () {
      var _determineDeviceCapabilities = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var _this10 = this;

        var proceedWithNativeLocationPrompt, _yield$this$determine, _yield$this$determine2, foreGroundLocationPermissions, currentLocation, backGroundLocationPermissions, _yield$Promise$all, _yield$Promise$all2, deviceAuth;

        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.rootStore.platformUtil.canShowNativeLocationPrompt();

              case 2:
                proceedWithNativeLocationPrompt = _context17.sent;
                this.rootStore.platformUtil.saveInLocalStorage("LOCATION_PROMPT_PERMISSION_FOR_NATIVE_POPUP_GRANTED", proceedWithNativeLocationPrompt.success.toString());

                if (!proceedWithNativeLocationPrompt.success) {
                  _context17.next = 17;
                  break;
                }

                _context17.next = 7;
                return this.determineForegroundLocationPermissionsAndCurrentPosition();

              case 7:
                _yield$this$determine = _context17.sent;
                _yield$this$determine2 = _slicedToArray(_yield$this$determine, 2);
                foreGroundLocationPermissions = _yield$this$determine2[0];
                currentLocation = _yield$this$determine2[1];
                _context17.next = 13;
                return this.rootStore.platformUtil.getBackgroundLocationPermissions();

              case 13:
                backGroundLocationPermissions = _context17.sent;
                runInAction(function () {
                  _this10.foreGroundLocationPermissions = foreGroundLocationPermissions;
                  _this10.backGroundLocationPermissions = backGroundLocationPermissions;

                  if (!_this10.currentUserLocation) {
                    _this10.currentUserLocation = currentLocation;
                  }
                });
                _context17.next = 20;
                break;

              case 17:
                this.foreGroundLocationPermissions = proceedWithNativeLocationPrompt.deniedPermissions;
                this.backGroundLocationPermissions = proceedWithNativeLocationPrompt.deniedPermissions;

                if (!this.currentUserLocation) {
                  this.currentUserLocation = null;
                }

              case 20:
                _context17.next = 22;
                return Promise.all([this.rootStore.platformUtil.determineDeviceAuthSupport(), this.determinePushNotificationsPermissionsPromptState(), this.determinePhotoLibraryPermissionsPromptState()]);

              case 22:
                _yield$Promise$all = _context17.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
                deviceAuth = _yield$Promise$all2[0];
                runInAction(function () {
                  _this10.deviceAuth = deviceAuth;
                });
                _context17.next = 28;
                return Promise.all([this.determineLocationPermissionsPromptState(), this.fetchSavedCredentials()]);

              case 28:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function determineDeviceCapabilities() {
        return _determineDeviceCapabilities.apply(this, arguments);
      }

      return determineDeviceCapabilities;
    }()
  }, {
    key: "obtainUserGeoCoordinates",
    value: function () {
      var _obtainUserGeoCoordinates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(enableHighAccuracy, timeout, maxage) {
        var _this11 = this;

        var currentLocation;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                if (!(this.currentUserLocation && this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP)) {
                  _context18.next = 2;
                  break;
                }

                return _context18.abrupt("return");

              case 2:
                _context18.next = 4;
                return this.rootStore.platformUtil.getCurrentGeoCoords(enableHighAccuracy, timeout, maxage);

              case 4:
                currentLocation = _context18.sent;

                if (currentLocation) {
                  // Send analytic event when guest allows permission
                  this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "locationEnabled", {}); // set location enabled flag to true

                  runInAction(function () {
                    _this11.foreGroundLocationPermissions = {
                      scope: null,
                      accuracy: null,
                      granted: true,
                      expires: null,
                      canAskAgain: false,
                      status: null
                    };
                  }); // set user coords

                  runInAction(function () {
                    _this11.currentUserLocation = currentLocation;
                  });
                } else {
                  runInAction(function () {
                    _this11.foreGroundLocationPermissions = {
                      scope: null,
                      accuracy: null,
                      granted: false,
                      expires: null,
                      canAskAgain: false,
                      status: null
                    };
                  });
                }

              case 6:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function obtainUserGeoCoordinates(_x6, _x7, _x8) {
        return _obtainUserGeoCoordinates.apply(this, arguments);
      }

      return obtainUserGeoCoordinates;
    }()
  }, {
    key: "updateSession",
    value: function () {
      var _updateSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var _this12 = this;

        var sessionDetails;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return DPServices.User.getSessionDetails(this.rootStore.platformUtil.getLocationPathName(), null, null, false);

              case 2:
                sessionDetails = _context19.sent;
                runInAction(function () {
                  _this12.sessionDetails = sessionDetails;
                });
                this.analyticsModel.setSessionDetails(sessionDetails);

              case 5:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function updateSession() {
        return _updateSession.apply(this, arguments);
      }

      return updateSession;
    }()
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(error) {
        var clearSavedCredentials,
            takeWebToMenu,
            _args20 = arguments;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                clearSavedCredentials = _args20.length > 1 && _args20[1] !== undefined ? _args20[1] : false;
                takeWebToMenu = _args20.length > 2 && _args20[2] !== undefined ? _args20[2] : true;
                _context20.prev = 2;

                if (error) {
                  this.rootStore.showError(error);
                }

                _context20.next = 6;
                return handle(DPServices.User.logout());

              case 6:
                _context20.next = 8;
                return handle(this.rootStore.platformUtil.clearLocalStorage(["USER_PROFILE", "ORDER_HISTORY", "FREQUENTLY_ORDERED_ITEMS", "FAVORITE_PRODUCTS"]));

              case 8:
                if (!(this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB)) {
                  _context20.next = 13;
                  break;
                }

                if (takeWebToMenu) {
                  this.rootStore.platformUtil.navigateToRoute("/menu");
                }

                this.rootStore.platformUtil.navReload();
                _context20.next = 22;
                break;

              case 13:
                this.loginModal.disableAutoLogin = true;
                this.loginModal.socialProfile = null;
                this.loginModal.promptBiometricAuth = false;

                if (!clearSavedCredentials) {
                  clearSavedCredentials = !(this.deviceAuth.hasHardWare && this.deviceAuth.isEnrolled);
                }

                if (!clearSavedCredentials) {
                  _context20.next = 20;
                  break;
                }

                _context20.next = 20;
                return this.rootStore.platformUtil.deleteFromSecureStore(SECURE_STORE_CRDS_KEY);

              case 20:
                _context20.next = 22;
                return this.rootStore.reloadApp({
                  disableAutoLogin: true
                });

              case 22:
                _context20.next = 26;
                break;

              case 24:
                _context20.prev = 24;
                _context20.t0 = _context20["catch"](2);

              case 26:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this, [[2, 24]]);
      }));

      function logout(_x9) {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                // Placeholder
                this.userProfile = null;
                this.sessionDetails = null;
                this.profileResponse = null;
                this.isAuthenticated = null;
                this.loginModal.reset();
                return _context21.abrupt("return", Promise.resolve());

              case 6:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "refreshSession",
    value: function () {
      var _refreshSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
        var credentials, username, password, socialMediaType, loginModel;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return this.getSavedCredentials();

              case 2:
                credentials = _context23.sent;

                if (!credentials) {
                  _context23.next = 18;
                  break;
                }

                username = credentials.username, password = credentials.password, socialMediaType = credentials.socialMediaType;
                loginModel = this.loginModal;
                loginModel.promptBiometricAuth = false;

                if (!socialMediaType) {
                  _context23.next = 13;
                  break;
                }

                loginModel.email = username;
                loginModel.socialUID = password;
                return _context23.abrupt("return", this.socialLogin());

              case 13:
                loginModel.email = username;
                loginModel.password = password;
                return _context23.abrupt("return", this.loginAndGetUserProfile());

              case 16:
                _context23.next = 19;
                break;

              case 18:
                throw Errors.NO_SAVED_CREDENTIALS;

              case 19:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function refreshSession() {
        return _refreshSession.apply(this, arguments);
      }

      return refreshSession;
    }()
  }, {
    key: "recordLoginFailureEvent",
    value: function () {
      var _recordLoginFailureEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
        var currentTimeStamp, _yield$handle, _yield$handle2, err, loginFailureAttemptsStr, loginFailureAttempts;

        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                currentTimeStamp = Date.now();
                _context24.next = 3;
                return handle(this.rootStore.platformUtil.getFromSecureStore("LOGIN_FAILURE_ATTEMPTS"));

              case 3:
                _yield$handle = _context24.sent;
                _yield$handle2 = _slicedToArray(_yield$handle, 2);
                err = _yield$handle2[0];
                loginFailureAttemptsStr = _yield$handle2[1];
                loginFailureAttempts = !err && loginFailureAttemptsStr ? convertFromString(loginFailureAttemptsStr) : [];

                if (loginFailureAttempts && loginFailureAttempts.length) {
                  loginFailureAttempts.push(currentTimeStamp);
                } else {
                  loginFailureAttempts = [currentTimeStamp];
                }

                _context24.next = 11;
                return handle(this.rootStore.platformUtil.saveInSecureStore("LOGIN_FAILURE_ATTEMPTS", JSON.stringify(loginFailureAttempts)));

              case 11:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function recordLoginFailureEvent() {
        return _recordLoginFailureEvent.apply(this, arguments);
      }

      return recordLoginFailureEvent;
    }()
  }, {
    key: "canPerformLogin",
    value: function () {
      var _canPerformLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
        var currentTimeStamp, _yield$handle3, _yield$handle4, err, loginFailureAttemptsStr, loginFailureAttempts, failedInLast10Min, failedIn10to20Min, failedInLast20Min;

        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                currentTimeStamp = Date.now();

                if (!(this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB)) {
                  _context25.next = 3;
                  break;
                }

                return _context25.abrupt("return", true);

              case 3:
                _context25.next = 5;
                return handle(this.rootStore.platformUtil.getFromSecureStore("LOGIN_FAILURE_ATTEMPTS"));

              case 5:
                _yield$handle3 = _context25.sent;
                _yield$handle4 = _slicedToArray(_yield$handle3, 2);
                err = _yield$handle4[0];
                loginFailureAttemptsStr = _yield$handle4[1];
                loginFailureAttempts = !err && loginFailureAttemptsStr ? convertFromString(loginFailureAttemptsStr) : [];

                if (!(loginFailureAttempts && loginFailureAttempts.length)) {
                  _context25.next = 20;
                  break;
                }

                failedInLast10Min = [];
                failedIn10to20Min = [];
                loginFailureAttempts.forEach(function (failureTs) {
                  var diff = currentTimeStamp - failureTs;

                  if (diff <= 10 * 60 * 1000) {
                    failedInLast10Min.push(failureTs);
                  } else if (diff <= 20 * 60 * 1000) {
                    failedIn10to20Min.push(failureTs);
                  } else {
                    console.log("========= Greater than 20 min");
                  }
                });
                failedInLast20Min = [].concat(failedInLast10Min, failedIn10to20Min);
                _context25.next = 17;
                return handle(this.rootStore.platformUtil.saveInSecureStore("LOGIN_FAILURE_ATTEMPTS", JSON.stringify(failedInLast20Min)));

              case 17:
                return _context25.abrupt("return", !(failedInLast20Min.length >= 10 || failedInLast10Min.length >= 5));

              case 20:
                return _context25.abrupt("return", true);

              case 21:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function canPerformLogin() {
        return _canPerformLogin.apply(this, arguments);
      }

      return canPerformLogin;
    }()
  }, {
    key: "attemptLoginWithSavedCredentials",
    value: function () {
      var _attemptLoginWithSavedCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
        var credentials, username, password, socialMediaType;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.next = 2;
                return this.getSavedCredentials();

              case 2:
                credentials = _context26.sent;

                if (!(credentials && !this.loginModal.disableAutoLogin)) {
                  _context26.next = 14;
                  break;
                }

                username = credentials.username, password = credentials.password, socialMediaType = credentials.socialMediaType;
                _context26.next = 7;
                return handle(DPServices.User.logout());

              case 7:
                if (!socialMediaType) {
                  _context26.next = 12;
                  break;
                }

                _context26.next = 10;
                return handle(DPServices.User.socialLogin(password, username));

              case 10:
                _context26.next = 14;
                break;

              case 12:
                _context26.next = 14;
                return handle(DPServices.User.login(username, password));

              case 14:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function attemptLoginWithSavedCredentials() {
        return _attemptLoginWithSavedCredentials.apply(this, arguments);
      }

      return attemptLoginWithSavedCredentials;
    }()
  }, {
    key: "loginAndGetUserProfile",
    value: function () {
      var _loginAndGetUserProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
        var _this13 = this;

        var currentTimeStamp, isExpired, userProfile, canPerformLogin, _yield$handle5, _yield$handle6, userProfileErr, userProfileResp;

        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                currentTimeStamp = Date.now();
                isExpired = currentTimeStamp - DPServices.User.lastSessionDetailTimeStamp > 1000 * 60 * 20;
                userProfile = null;

                if (!(!this.isLoggedIn || isExpired)) {
                  _context27.next = 25;
                  break;
                }

                _context27.next = 6;
                return this.canPerformLogin();

              case 6:
                canPerformLogin = _context27.sent;

                if (canPerformLogin) {
                  _context27.next = 9;
                  break;
                }

                throw Errors.LOGIN_FRAUD_ERROR;

              case 9:
                _context27.next = 11;
                return handle(DPServices.User.loginAndGetUserProfile(this.loginModal.email.toLowerCase(), this.loginModal.password));

              case 11:
                _yield$handle5 = _context27.sent;
                _yield$handle6 = _slicedToArray(_yield$handle5, 2);
                userProfileErr = _yield$handle6[0];
                userProfileResp = _yield$handle6[1];

                if (!userProfileErr) {
                  _context27.next = 21;
                  break;
                }

                _context27.next = 18;
                return this.recordLoginFailureEvent();

              case 18:
                throw userProfileErr;

              case 21:
                userProfile = userProfileResp;

              case 22:
                this.saveCredentials(this.loginModal.email.toLowerCase(), this.loginModal.password, null);
                _context27.next = 26;
                break;

              case 25:
                userProfile = this.userProfile;

              case 26:
                if (userProfile) {
                  this.cacheUserProfile(userProfile);
                  this.postLogin(userProfile);
                } else {
                  runInAction(function () {
                    _this13.loginModal.disableAutoLogin = false;
                    _this13.isAuthenticated = true;
                  });
                }

              case 27:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function loginAndGetUserProfile() {
        return _loginAndGetUserProfile.apply(this, arguments);
      }

      return loginAndGetUserProfile;
    }()
  }, {
    key: "accountCreationEvent",
    value: function () {
      var _accountCreationEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(zipCode, state, country, birthYear, restId, restaurantNum) {
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                this.analyticsModel.dispatchOrderConfirmationAccCreat(zipCode, state, country, birthYear, restId, restaurantNum);

              case 1:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function accountCreationEvent(_x10, _x11, _x12, _x13, _x14, _x15) {
        return _accountCreationEvent.apply(this, arguments);
      }

      return accountCreationEvent;
    }()
  }, {
    key: "signUpAndGetUserProfile",
    value: function () {
      var _signUpAndGetUserProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29() {
        var _signUpModel$socialLi,
            _signUpModel$socialLi2,
            _signUpModel$socialLi3,
            _this14 = this;

        var signUpModel, dobData, dobDate, dobMonth, dobYear, payload, _yield$handle7, _yield$handle8, error, userProfile, errorDescription;

        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                signUpModel = this.signUpModel;
                dobData = signUpModel.dob.split("/");
                dobDate = dobData[0];
                dobMonth = dobData[1];
                dobYear = dobData[2];
                payload = {
                  email: signUpModel.email.toLowerCase(),
                  password: signUpModel.password,
                  firstName: signUpModel.firstName,
                  lastName: signUpModel.lastName,
                  phone: signUpModel.phoneNumber,
                  restaurantAddressType: "Primary",
                  restaurantCity: signUpModel.restaurantDetails.restaurantCity,
                  restaurantState: signUpModel.restaurantDetails.restaurantState,
                  restaurantZip: signUpModel.restaurantDetails.restaurantZipCode,
                  restaurantAddressLine1: signUpModel.restaurantDetails.restaurantAddressLineOne,
                  restaurantAddressLine2: signUpModel.restaurantDetails.restaurantAddressLineTwo,
                  restaurantCountry: signUpModel.restaurantDetails.restaurantCountry,
                  guestType: "registered",
                  preferredRestaurantId: signUpModel.restaurantDetails.restaurantId,
                  dobDay: dobDate,
                  dobMonth: dobMonth,
                  dobYear: dobYear,
                  primaryEmailOptin: signUpModel.subscribeToOffers ? "P" : "",
                  socialEmail: (_signUpModel$socialLi = signUpModel.socialLinkData) === null || _signUpModel$socialLi === void 0 ? void 0 : _signUpModel$socialLi.email,
                  socialMediaType: (_signUpModel$socialLi2 = signUpModel.socialLinkData) === null || _signUpModel$socialLi2 === void 0 ? void 0 : _signUpModel$socialLi2.mediaType,
                  socialUID: (_signUpModel$socialLi3 = signUpModel.socialLinkData) === null || _signUpModel$socialLi3 === void 0 ? void 0 : _signUpModel$socialLi3.socialUID
                };
                this.accountCreationEvent(signUpModel.restaurantDetails.restaurantZipCode.substring(0, 5), signUpModel.restaurantDetails.restaurantState, "US", dobYear === null || dobYear === void 0 ? void 0 : dobYear.toString(), signUpModel.restaurantDetails.restaurantId, signUpModel.restaurantDetails.restaurantNum);
                _context29.next = 9;
                return handle(DPServices.User.signUpAndGetUserProfile(payload));

              case 9:
                _yield$handle7 = _context29.sent;
                _yield$handle8 = _slicedToArray(_yield$handle7, 2);
                error = _yield$handle8[0];
                userProfile = _yield$handle8[1];

                if (!error) {
                  _context29.next = 16;
                  break;
                }

                errorDescription = DPServices.Common.checkAndGetErrorDescription(error, {
                  faultCode: "userAlreadyExists",
                  faultCodeDescriptionOverride: "A user already exists with the login ".concat(signUpModel.email)
                }) || Errors.CREATE_ACCOUNT_FAILURE;
                throw errorDescription;

              case 16:
                this.saveCredentials(signUpModel.email.toLowerCase(), signUpModel.password, null);
                signUpModel.resetValues();

                if (userProfile) {
                  this.cacheUserProfile(userProfile);
                  this.postLogin(userProfile);
                } else {
                  runInAction(function () {
                    _this14.isAuthenticated = true;
                    _this14.loginModal.disableAutoLogin = false;
                    _this14.loginModal.promptBiometricAuth = false;
                  });
                }

              case 19:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function signUpAndGetUserProfile() {
        return _signUpAndGetUserProfile.apply(this, arguments);
      }

      return signUpAndGetUserProfile;
    }()
  }, {
    key: "getFromLegacyStorage",
    value: function () {
      var _getFromLegacyStorage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(appleSignInRef) {
        var oldEncrytedEmail, oldEmail, oldEncrytedFirstName, oldFirstName, oldEncrytedLastName, oldLastName;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.next = 2;
                return this.rootStore.platformUtil.getFromOldKeyChain("userEmailSiwa");

              case 2:
                oldEncrytedEmail = _context30.sent;
                console.log("+++++++Encrypted Email" + oldEncrytedEmail);

                if (!oldEncrytedEmail) {
                  _context30.next = 10;
                  break;
                }

                _context30.next = 7;
                return DPServices.User.decryptLegacyEncryptedData(oldEncrytedEmail);

              case 7:
                oldEmail = _context30.sent;
                console.log("-------Decrypted email=" + oldEmail);
                appleSignInRef.email = oldEmail;

              case 10:
                _context30.next = 12;
                return this.rootStore.platformUtil.getFromOldKeyChain("firstNameSiwa");

              case 12:
                oldEncrytedFirstName = _context30.sent;
                console.log("+++++++Encrypted FirstName" + oldEncrytedFirstName);

                if (!oldEncrytedFirstName) {
                  _context30.next = 20;
                  break;
                }

                _context30.next = 17;
                return DPServices.User.decryptLegacyEncryptedData(oldEncrytedFirstName);

              case 17:
                oldFirstName = _context30.sent;
                console.log("-------Decrypted FirstName=" + oldFirstName);
                appleSignInRef.fullName.givenName = oldFirstName;

              case 20:
                _context30.next = 22;
                return this.rootStore.platformUtil.getFromOldKeyChain("lastNameSiwa");

              case 22:
                oldEncrytedLastName = _context30.sent;
                console.log("+++++++Encrypted LastName" + oldEncrytedLastName);

                if (!oldEncrytedLastName) {
                  _context30.next = 30;
                  break;
                }

                _context30.next = 27;
                return DPServices.User.decryptLegacyEncryptedData(oldEncrytedLastName);

              case 27:
                oldLastName = _context30.sent;
                console.log("-------Decrypted LastName=" + oldLastName);
                appleSignInRef.fullName.familyName = oldLastName;

              case 30:
                return _context30.abrupt("return", appleSignInRef);

              case 31:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function getFromLegacyStorage(_x16) {
        return _getFromLegacyStorage.apply(this, arguments);
      }

      return getFromLegacyStorage;
    }()
  }, {
    key: "performAppleSignIn",
    value: function () {
      var _performAppleSignIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(appleSignInRef) {
        var _this15 = this;

        var _yield$handle9, _yield$handle10, err, savedAppleSignInCredsStr;

        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                if (!appleSignInRef.email) {
                  _context31.next = 5;
                  break;
                }

                _context31.next = 3;
                return handle(this.rootStore.platformUtil.saveInSecureStore("APPLE_SIGN_IN_CREDENTIALS", JSON.stringify(appleSignInRef)));

              case 3:
                _context31.next = 22;
                break;

              case 5:
                _context31.next = 7;
                return handle(this.rootStore.platformUtil.getFromSecureStore("APPLE_SIGN_IN_CREDENTIALS"));

              case 7:
                _yield$handle9 = _context31.sent;
                _yield$handle10 = _slicedToArray(_yield$handle9, 2);
                err = _yield$handle10[0];
                savedAppleSignInCredsStr = _yield$handle10[1];

                if (!savedAppleSignInCredsStr) {
                  _context31.next = 15;
                  break;
                }

                appleSignInRef = JSON.parse(savedAppleSignInCredsStr);
                _context31.next = 22;
                break;

              case 15:
                _context31.next = 17;
                return this.getFromLegacyStorage(appleSignInRef);

              case 17:
                appleSignInRef = _context31.sent;
                console.log(" after legacy hydration: " + JSON.stringify(appleSignInRef));

                if (!(appleSignInRef.email && appleSignInRef.fullName.givenName && appleSignInRef.fullName.familyName)) {
                  _context31.next = 22;
                  break;
                }

                _context31.next = 22;
                return handle(this.rootStore.platformUtil.saveInSecureStore("APPLE_SIGN_IN_CREDENTIALS", JSON.stringify(appleSignInRef)));

              case 22:
                console.log("*** inside performAppleSigin appleSignInRef=" + JSON.stringify(appleSignInRef));
                this.loginModal.socialUID = appleSignInRef.user;
                this.loginModal.email = appleSignInRef.email;
                this.loginModal.socialMediaType = UserTypes.SocialMediaType.APPLE;
                runInAction(function () {
                  _this15.loginModal.socialProfile = {
                    id: appleSignInRef.user,
                    type: UserTypes.SocialMediaType.APPLE,
                    email: appleSignInRef.email,
                    firstName: appleSignInRef.fullName.givenName,
                    lastName: appleSignInRef.fullName.familyName,
                    picture: {
                      url: null
                    }
                  };
                });
                _context31.next = 29;
                return this.socialLogin();

              case 29:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function performAppleSignIn(_x17) {
        return _performAppleSignIn.apply(this, arguments);
      }

      return performAppleSignIn;
    }()
  }, {
    key: "performGoogleSignIn",
    value: function () {
      var _performGoogleSignIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(accessToken) {
        var _this16 = this;

        var googleUserInfo;
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                _context32.next = 2;
                return DPServices.User.getGoogleUserInfo(accessToken);

              case 2:
                googleUserInfo = _context32.sent;
                this.loginModal.socialUID = googleUserInfo.id;
                this.loginModal.email = googleUserInfo.email;
                this.loginModal.socialMediaType = UserTypes.SocialMediaType.GOOGLEPLUS;
                runInAction(function () {
                  _this16.loginModal.socialProfile = googleUserInfo;
                });
                _context32.next = 9;
                return this.socialLogin();

              case 9:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function performGoogleSignIn(_x18) {
        return _performGoogleSignIn.apply(this, arguments);
      }

      return performGoogleSignIn;
    }()
  }, {
    key: "performFacebookSignIn",
    value: function () {
      var _performFacebookSignIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(accessToken) {
        var _this17 = this;

        var facebookUserInfo;
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _context33.next = 2;
                return DPServices.User.getFacebookUserInfo(accessToken);

              case 2:
                facebookUserInfo = _context33.sent;
                this.loginModal.socialUID = facebookUserInfo.id;
                this.loginModal.email = facebookUserInfo.email;
                this.loginModal.socialMediaType = UserTypes.SocialMediaType.FACEBOOK;
                runInAction(function () {
                  _this17.loginModal.socialProfile = facebookUserInfo;
                });
                _context33.next = 9;
                return this.socialLogin();

              case 9:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function performFacebookSignIn(_x19) {
        return _performFacebookSignIn.apply(this, arguments);
      }

      return performFacebookSignIn;
    }()
  }, {
    key: "setCreateAccountFields",
    value: function setCreateAccountFields() {
      var _this$loginModal$soci, _this$loginModal$soci2;

      this.signUpModel.firstName = (_this$loginModal$soci = this.loginModal.socialProfile.firstName) === null || _this$loginModal$soci === void 0 ? void 0 : _this$loginModal$soci.trim();
      this.signUpModel.lastName = (_this$loginModal$soci2 = this.loginModal.socialProfile.lastName) === null || _this$loginModal$soci2 === void 0 ? void 0 : _this$loginModal$soci2.trim();
      this.signUpModel.email = this.loginModal.socialProfile.email;
      this.signUpModel.socialLinkData = {
        email: this.loginModal.socialProfile.email,
        mediaType: this.loginModal.socialMediaType,
        socialUID: this.loginModal.socialUID
      };
    }
  }, {
    key: "socialLogin",
    value: function () {
      var _socialLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34() {
        var _this18 = this;

        var currentTimeStamp, isExpired, userProfile, _this$loginModal$emai, _this$loginModal$emai2, _yield$handle11, _yield$handle12, err, usrProfile, _response, _response$data;

        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                currentTimeStamp = Date.now();
                isExpired = currentTimeStamp - DPServices.User.lastSessionDetailTimeStamp > 1000 * 60 * 20;
                userProfile = null;

                if (!(!this.isLoggedIn || isExpired)) {
                  _context34.next = 19;
                  break;
                }

                console.log("this.loginModal.socialUID=" + this.loginModal.socialUID + ", this.loginModal.email?.toLowerCase()=" + ((_this$loginModal$emai = this.loginModal.email) === null || _this$loginModal$emai === void 0 ? void 0 : _this$loginModal$emai.toLowerCase()));
                _context34.next = 7;
                return handle(DPServices.User.socialLoginAndGetUserProfile(this.loginModal.socialUID, (_this$loginModal$emai2 = this.loginModal.email) === null || _this$loginModal$emai2 === void 0 ? void 0 : _this$loginModal$emai2.toLowerCase()));

              case 7:
                _yield$handle11 = _context34.sent;
                _yield$handle12 = _slicedToArray(_yield$handle11, 2);
                err = _yield$handle12[0];
                usrProfile = _yield$handle12[1];

                if (!err) {
                  _context34.next = 14;
                  break;
                }

                if ((err === null || err === void 0 ? void 0 : (_response = err.response) === null || _response === void 0 ? void 0 : (_response$data = _response.data) === null || _response$data === void 0 ? void 0 : _response$data.profileStatus) === "The account is not registered") {
                  this.setCreateAccountFields();
                }

                throw err;

              case 14:
                userProfile = usrProfile;
                _context34.next = 17;
                return this.saveCredentials(this.loginModal.email, this.loginModal.socialUID, this.loginModal.socialMediaType);

              case 17:
                _context34.next = 20;
                break;

              case 19:
                userProfile = this.userProfile;

              case 20:
                if (userProfile) {
                  this.cacheUserProfile(userProfile);
                  this.postLogin(userProfile);
                } else {
                  runInAction(function () {
                    _this18.loginModal.disableAutoLogin = false;
                    _this18.isAuthenticated = true;
                  });
                }

              case 21:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));

      function socialLogin() {
        return _socialLogin.apply(this, arguments);
      }

      return socialLogin;
    }()
  }, {
    key: "postLogin",
    value: function () {
      var _postLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(userProfile) {
        var _this$loginModal,
            _this$loginModal$user,
            _this19 = this;

        var sessionDetails;
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                this.loginModal.promptBiometricAuth = false;
                _context35.next = 3;
                return DPServices.User.getSessionDetails(this.rootStore.platformUtil.getLocationPathName(), null, null, false);

              case 3:
                sessionDetails = _context35.sent;

                if (userProfile.login !== ((_this$loginModal = this.loginModal) === null || _this$loginModal === void 0 ? void 0 : (_this$loginModal$user = _this$loginModal.userSelectedProfilePicture) === null || _this$loginModal$user === void 0 ? void 0 : _this$loginModal$user.email)) {
                  runInAction(function () {
                    _this19.loginModal.userSelectedProfilePicture = null;
                  });
                  this.analyticsModel.setSessionDetails(sessionDetails);
                }

                runInAction(function () {
                  _this19.sessionDetails = sessionDetails;
                  _this19.userProfile = userProfile;
                  _this19.isAuthenticated = true;
                  _this19.loginModal.disableAutoLogin = false;
                });

              case 6:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));

      function postLogin(_x20) {
        return _postLogin.apply(this, arguments);
      }

      return postLogin;
    }()
  }, {
    key: "_performSocialLinkandLogin",
    value: function () {
      var _performSocialLinkandLogin2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36() {
        var _this20 = this;

        var email, password, savedCreds, _yield$handle13, _yield$handle14, userProfileErr, userProfileResp, errorDescription, _yield$handle15, _yield$handle16, errorResponse, profileResponse, _errorDescription;

        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                email = this.loginModal.email.toLowerCase();
                password = this.loginModal.password;
                _context36.next = 4;
                return this.getSavedCredentials();

              case 4:
                savedCreds = _context36.sent;
                console.log("*** saved Creds preform social link====>", savedCreds);

                if (savedCreds && savedCreds.socialMediaType === "apple") {
                  email = savedCreds === null || savedCreds === void 0 ? void 0 : savedCreds.username;
                  password = savedCreds === null || savedCreds === void 0 ? void 0 : savedCreds.password;
                }

                _context36.next = 9;
                return handle(DPServices.User.loginAndGetUserProfile(email, password));

              case 9:
                _yield$handle13 = _context36.sent;
                _yield$handle14 = _slicedToArray(_yield$handle13, 2);
                userProfileErr = _yield$handle14[0];
                userProfileResp = _yield$handle14[1];

                if (!userProfileErr) {
                  _context36.next = 16;
                  break;
                }

                errorDescription = DPServices.Common.checkAndGetErrorDescription(userProfileErr) || Errors.SOCIAL_LINK_FAILED;
                throw errorDescription;

              case 16:
                _context36.next = 18;
                return handle(DPServices.User.performSocialLink(this.loginModal.email, this.loginModal.socialUID, this.loginModal.socialMediaType));

              case 18:
                _yield$handle15 = _context36.sent;
                _yield$handle16 = _slicedToArray(_yield$handle15, 2);
                errorResponse = _yield$handle16[0];
                profileResponse = _yield$handle16[1];

                if (!errorResponse) {
                  _context36.next = 26;
                  break;
                }

                runInAction(function () {
                  _this20.loginModal.socialProfile = null;
                });
                _errorDescription = DPServices.Common.checkAndGetErrorDescription(errorResponse) || Errors.SOCIAL_LINK_FAILED;
                throw _errorDescription;

              case 26:
                if (!(profileResponse !== null && profileResponse !== void 0 && profileResponse.successResponse)) {
                  _context36.next = 32;
                  break;
                }

                _context36.next = 29;
                return this.saveCredentials(this.loginModal.email, this.loginModal.socialUID, this.loginModal.socialMediaType);

              case 29:
                if (userProfileResp) {
                  this.cacheUserProfile(userProfileResp);
                  this.postLogin(userProfileResp);
                } else {
                  runInAction(function () {
                    _this20.loginModal.disableAutoLogin = false;
                    _this20.isAuthenticated = true;
                  });
                }

                _context36.next = 33;
                break;

              case 32:
                runInAction(function () {
                  _this20.loginModal.socialProfile = null;
                });

              case 33:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));

      function _performSocialLinkandLogin() {
        return _performSocialLinkandLogin2.apply(this, arguments);
      }

      return _performSocialLinkandLogin;
    }()
  }, {
    key: "socialLink",
    value: function () {
      var _socialLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37() {
        var clearSavedCredentials;
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                _context37.prev = 0;
                _context37.next = 3;
                return this._performSocialLinkandLogin();

              case 3:
                _context37.next = 13;
                break;

              case 5:
                _context37.prev = 5;
                _context37.t0 = _context37["catch"](0);
                clearSavedCredentials = !(this.deviceAuth.hasHardWare && this.deviceAuth.isEnrolled);

                if (!clearSavedCredentials) {
                  _context37.next = 11;
                  break;
                }

                _context37.next = 11;
                return this.rootStore.platformUtil.deleteFromSecureStore(SECURE_STORE_CRDS_KEY);

              case 11:
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context37.t0.message, null, {
                  okBtnText: "Okay",
                  okBtnOnClick: function okBtnOnClick() {
                    handle(DPServices.User.logout());
                  }
                });
                throw _context37.t0;

              case 13:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this, [[0, 5]]);
      }));

      function socialLink() {
        return _socialLink.apply(this, arguments);
      }

      return socialLink;
    }()
  }, {
    key: "navigateToSocialRegistration",
    value: function navigateToSocialRegistration(user) {
      var isMobileSite = this.rootStore.isMobile;
      var redirectUrl = "/customer-service/social-registration?";

      if (isMobileSite) {
        redirectUrl = redirectUrl + "regSocialUID=" + user._profile.id + "&regSocialFirstName=" + user._profile.firstName + "&regSocialLastName=" + user._profile.lastName + "&regSocialEmailId=" + user._profile.email;
      } else {
        redirectUrl = redirectUrl + "socialUid=" + user._profile.id + "&socialFirstName=" + user._profile.firstName + "&socialLastName=" + user._profile.lastName + "&socialEmailId=" + user._profile.email;
      }

      this.rootStore.refreshInProgress = true;
      this.rootStore.platformUtil.redirectToURL(redirectUrl);
    }
  }, {
    key: "getSavedCredentials",
    value: function () {
      var _getSavedCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38() {
        var isSecureStoreAvailable, credentialsJsonStr;
        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                _context38.next = 2;
                return this.rootStore.platformUtil.isSecureStoreAvailable();

              case 2:
                isSecureStoreAvailable = _context38.sent;

                if (!isSecureStoreAvailable) {
                  _context38.next = 14;
                  break;
                }

                _context38.next = 6;
                return this.rootStore.platformUtil.getFromSecureStore(SECURE_STORE_CRDS_KEY);

              case 6:
                credentialsJsonStr = _context38.sent;

                if (!credentialsJsonStr) {
                  _context38.next = 11;
                  break;
                }

                return _context38.abrupt("return", JSON.parse(credentialsJsonStr));

              case 11:
                return _context38.abrupt("return", null);

              case 12:
                _context38.next = 15;
                break;

              case 14:
                return _context38.abrupt("return", null);

              case 15:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));

      function getSavedCredentials() {
        return _getSavedCredentials.apply(this, arguments);
      }

      return getSavedCredentials;
    }()
  }, {
    key: "saveCredentials",
    value: function saveCredentials(username, password, socialMediaType) {
      var credentials = {
        password: password,
        username: username,
        socialMediaType: socialMediaType
      };

      if (!socialMediaType) {
        delete credentials.socialMediaType;
      }

      return this.rootStore.platformUtil.saveInSecureStore(SECURE_STORE_CRDS_KEY, JSON.stringify(credentials));
    }
  }, {
    key: "whenAppActive",
    value: function () {
      var _whenAppActive = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39() {
        var _this$rootStore, _this$rootStore$joinW;

        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                _context39.next = 2;
                return Promise.all([this.determineDeviceCapabilities(), (_this$rootStore = this.rootStore) === null || _this$rootStore === void 0 ? void 0 : (_this$rootStore$joinW = _this$rootStore.joinWaitlist) === null || _this$rootStore$joinW === void 0 ? void 0 : _this$rootStore$joinW.loadAndSetWaitlistId()]);

              case 2:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));

      function whenAppActive() {
        return _whenAppActive.apply(this, arguments);
      }

      return whenAppActive;
    }()
  }, {
    key: "updateFirstName",
    value: function () {
      var _updateFirstName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40() {
        var _this21 = this;

        var _this$userProfile, _this$userProfileMode, _this$userProfile2, _this$userProfile3, userId, payload, _yield$handle17, _yield$handle18, err, response, _DPServices$Cart$pars, errObj, faults, haveErrorDescription;

        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                _context40.prev = 0;
                userId = (_this$userProfile = this.userProfile) === null || _this$userProfile === void 0 ? void 0 : _this$userProfile.userId;
                payload = {
                  firstName: (_this$userProfileMode = this.userProfileModel) === null || _this$userProfileMode === void 0 ? void 0 : _this$userProfileMode.updatedUserFirstName,
                  lastName: (_this$userProfile2 = this.userProfile) === null || _this$userProfile2 === void 0 ? void 0 : _this$userProfile2.lastName,
                  login: (_this$userProfile3 = this.userProfile) === null || _this$userProfile3 === void 0 ? void 0 : _this$userProfile3.login
                };
                _context40.next = 5;
                return handle(DPServices.User.updateFirstName(payload, userId));

              case 5:
                _yield$handle17 = _context40.sent;
                _yield$handle18 = _slicedToArray(_yield$handle17, 2);
                err = _yield$handle18[0];
                response = _yield$handle18[1];

                if (!response) {
                  _context40.next = 14;
                  break;
                }

                runInAction(function () {
                  _this21.userProfile = response;
                });
                this.cacheUserProfile(response);
                _context40.next = 22;
                break;

              case 14:
                errObj = err;
                faults = (_DPServices$Cart$pars = DPServices.Cart.parseErrors(errObj)) === null || _DPServices$Cart$pars === void 0 ? void 0 : _DPServices$Cart$pars.faults;
                haveErrorDescription = faults && faults[0] && faults[0].faultDescription;

                if (!haveErrorDescription) {
                  _context40.next = 21;
                  break;
                }

                throw new Error(haveErrorDescription);

              case 21:
                throw Errors.UPDATE_FIRST_NAME_FAILED;

              case 22:
                this.userProfileModel.resetValues();
                _context40.next = 29;
                break;

              case 25:
                _context40.prev = 25;
                _context40.t0 = _context40["catch"](0);
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context40.t0.message, null, {
                  okBtnText: "Home",
                  okBtnOnClick: function okBtnOnClick() {
                    _this21.rootStore.reloadApp();
                  }
                });
                throw _context40.t0;

              case 29:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this, [[0, 25]]);
      }));

      function updateFirstName() {
        return _updateFirstName.apply(this, arguments);
      }

      return updateFirstName;
    }()
  }, {
    key: "updateSecurityQuestionAnswer",
    value: function () {
      var _updateSecurityQuestionAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41() {
        var _this22 = this;

        var _this$userProfile4, _this$userProfileMode2, _this$userProfileMode3, _this$userProfile5, _this$userProfileMode4, userId, payload, _yield$handle19, _yield$handle20, err, response, _DPServices$Cart$pars2, errObj, faults, haveErrorDescription;

        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                _context41.prev = 0;
                userId = (_this$userProfile4 = this.userProfile) === null || _this$userProfile4 === void 0 ? void 0 : _this$userProfile4.userId;
                payload = {
                  securityQuestion: (_this$userProfileMode2 = this.userProfileModel) === null || _this$userProfileMode2 === void 0 ? void 0 : _this$userProfileMode2.userSecurityQuestion,
                  securityAnswer: (_this$userProfileMode3 = this.userProfileModel) === null || _this$userProfileMode3 === void 0 ? void 0 : _this$userProfileMode3.userSecurityAnswer,
                  login: (_this$userProfile5 = this.userProfile) === null || _this$userProfile5 === void 0 ? void 0 : _this$userProfile5.login
                };
                _context41.next = 5;
                return handle(DPServices.User.updateSecurityQuestionAnswer(payload, userId));

              case 5:
                _yield$handle19 = _context41.sent;
                _yield$handle20 = _slicedToArray(_yield$handle19, 2);
                err = _yield$handle20[0];
                response = _yield$handle20[1];

                if (!err) {
                  _context41.next = 18;
                  break;
                }

                errObj = err;
                faults = (_DPServices$Cart$pars2 = DPServices.Cart.parseErrors(errObj)) === null || _DPServices$Cart$pars2 === void 0 ? void 0 : _DPServices$Cart$pars2.faults;
                haveErrorDescription = faults && faults[0] && faults[0].faultDescription;

                if (!haveErrorDescription) {
                  _context41.next = 17;
                  break;
                }

                throw new Error(haveErrorDescription);

              case 17:
                throw Errors.UPDATE_SECURITY_QUESTION_FAILED;

              case 18:
                runInAction(function () {
                  _this22.userProfile = response;
                });
                this.cacheUserProfile(response);
                (_this$userProfileMode4 = this.userProfileModel) === null || _this$userProfileMode4 === void 0 ? void 0 : _this$userProfileMode4.resetValues();
                _context41.next = 27;
                break;

              case 23:
                _context41.prev = 23;
                _context41.t0 = _context41["catch"](0);
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context41.t0.message, null, {
                  okBtnText: "Home",
                  okBtnOnClick: function okBtnOnClick() {
                    _this22.rootStore.reloadApp();
                  }
                });
                throw _context41.t0;

              case 27:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this, [[0, 23]]);
      }));

      function updateSecurityQuestionAnswer() {
        return _updateSecurityQuestionAnswer.apply(this, arguments);
      }

      return updateSecurityQuestionAnswer;
    }()
  }, {
    key: "updatePhoneNumber",
    value: function () {
      var _updatePhoneNumber = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42() {
        var _this23 = this;

        var _this$userProfile6, _this$userProfile7, _this$userProfile7$de, _this$userProfile8, _this$userProfile8$de, _this$userProfileMode5, userId, phoneAction, payload, _yield$handle21, _yield$handle22, err, response, _DPServices$Cart$pars3, errObj, faults, haveErrorDescription;

        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                _context42.prev = 0;
                userId = (_this$userProfile6 = this.userProfile) === null || _this$userProfile6 === void 0 ? void 0 : _this$userProfile6.userId;
                phoneAction = "editPhone";

                if (!((_this$userProfile7 = this.userProfile) !== null && _this$userProfile7 !== void 0 && (_this$userProfile7$de = _this$userProfile7.defaultPhone) !== null && _this$userProfile7$de !== void 0 && _this$userProfile7$de.phoneId)) {
                  phoneAction = "addPhone";
                }

                payload = {
                  phone: {
                    "atg-rest-class-type": "java.util.HashMap",
                    "atg-rest-values": {
                      phoneExt: "",
                      phoneType: "Mobile",
                      phoneAction: phoneAction,
                      phoneId: (_this$userProfile8 = this.userProfile) === null || _this$userProfile8 === void 0 ? void 0 : (_this$userProfile8$de = _this$userProfile8.defaultPhone) === null || _this$userProfile8$de === void 0 ? void 0 : _this$userProfile8$de.phoneId,
                      phone: (_this$userProfileMode5 = this.userProfileModel) === null || _this$userProfileMode5 === void 0 ? void 0 : _this$userProfileMode5.updatedUserMobileNumber
                    }
                  }
                };
                _context42.next = 7;
                return handle(DPServices.User.updatePhoneNumber(payload, userId));

              case 7:
                _yield$handle21 = _context42.sent;
                _yield$handle22 = _slicedToArray(_yield$handle21, 2);
                err = _yield$handle22[0];
                response = _yield$handle22[1];

                if (!err) {
                  _context42.next = 20;
                  break;
                }

                errObj = err;
                faults = (_DPServices$Cart$pars3 = DPServices.Cart.parseErrors(errObj)) === null || _DPServices$Cart$pars3 === void 0 ? void 0 : _DPServices$Cart$pars3.faults;
                haveErrorDescription = faults && faults[0] && faults[0].faultDescription;

                if (!haveErrorDescription) {
                  _context42.next = 19;
                  break;
                }

                throw new Error(haveErrorDescription);

              case 19:
                throw Errors.UPDATE_PHONE_NUMBER_FAILED;

              case 20:
                runInAction(function () {
                  _this23.userProfile = response;
                });
                this.cacheUserProfile(response);
                _context42.next = 28;
                break;

              case 24:
                _context42.prev = 24;
                _context42.t0 = _context42["catch"](0);
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context42.t0.message, null, {
                  okBtnText: "Home",
                  okBtnOnClick: function okBtnOnClick() {
                    _this23.rootStore.reloadApp();
                  }
                });
                throw _context42.t0;

              case 28:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this, [[0, 24]]);
      }));

      function updatePhoneNumber() {
        return _updatePhoneNumber.apply(this, arguments);
      }

      return updatePhoneNumber;
    }()
  }, {
    key: "updateEmailAddress",
    value: function () {
      var _updateEmailAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43() {
        var _this24 = this;

        var _this$userProfile9, _this$userProfile10, _this$userProfileMode6, userId, payload, _yield$handle23, _yield$handle24, err, response, _DPServices$Cart$pars4, errObj, faults, haveErrorDescription;

        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                _context43.prev = 0;
                userId = (_this$userProfile9 = this.userProfile) === null || _this$userProfile9 === void 0 ? void 0 : _this$userProfile9.userId;
                payload = {
                  login: (_this$userProfile10 = this.userProfile) === null || _this$userProfile10 === void 0 ? void 0 : _this$userProfile10.login,
                  newEmail: (_this$userProfileMode6 = this.userProfileModel) === null || _this$userProfileMode6 === void 0 ? void 0 : _this$userProfileMode6.newUserEmailAddress
                };
                _context43.next = 5;
                return handle(DPServices.User.updateEmailAddress(payload, userId));

              case 5:
                _yield$handle23 = _context43.sent;
                _yield$handle24 = _slicedToArray(_yield$handle23, 2);
                err = _yield$handle24[0];
                response = _yield$handle24[1];

                if (!err) {
                  _context43.next = 18;
                  break;
                }

                errObj = err;
                faults = (_DPServices$Cart$pars4 = DPServices.Cart.parseErrors(errObj)) === null || _DPServices$Cart$pars4 === void 0 ? void 0 : _DPServices$Cart$pars4.faults;
                haveErrorDescription = faults && faults[0] && faults[0].faultDescription;

                if (!haveErrorDescription) {
                  _context43.next = 17;
                  break;
                }

                throw new Error(haveErrorDescription);

              case 17:
                throw Errors.UPDATE_EMAIL_ADDRESS_FAILED;

              case 18:
                runInAction(function () {
                  _this24.userProfile = response;
                });
                this.cacheUserProfile(response);
                _context43.next = 26;
                break;

              case 22:
                _context43.prev = 22;
                _context43.t0 = _context43["catch"](0);
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context43.t0.message, null, {
                  okBtnText: "Home",
                  okBtnOnClick: function okBtnOnClick() {
                    _this24.rootStore.reloadApp();
                  }
                });
                throw _context43.t0;

              case 26:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, this, [[0, 22]]);
      }));

      function updateEmailAddress() {
        return _updateEmailAddress.apply(this, arguments);
      }

      return updateEmailAddress;
    }()
  }, {
    key: "updateUserLastName",
    value: function () {
      var _updateUserLastName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44() {
        var _this25 = this;

        var _this$userProfile11, _this$userProfile12, userId, profileModel, userLastName, payload, _yield$handle25, _yield$handle26, err, response, _DPServices$Cart$pars5, errObj, faults, haveErrorDescription;

        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                _context44.prev = 0;
                userId = (_this$userProfile11 = this.userProfile) === null || _this$userProfile11 === void 0 ? void 0 : _this$userProfile11.userId;
                profileModel = this.userProfileModel;
                userLastName = profileModel.userLastName;
                payload = {
                  lastName: userLastName,
                  login: (_this$userProfile12 = this.userProfile) === null || _this$userProfile12 === void 0 ? void 0 : _this$userProfile12.login
                };
                _context44.next = 7;
                return handle(DPServices.User.updateLastName(payload, userId));

              case 7:
                _yield$handle25 = _context44.sent;
                _yield$handle26 = _slicedToArray(_yield$handle25, 2);
                err = _yield$handle26[0];
                response = _yield$handle26[1];

                if (!err) {
                  _context44.next = 20;
                  break;
                }

                errObj = err;
                faults = (_DPServices$Cart$pars5 = DPServices.Cart.parseErrors(errObj)) === null || _DPServices$Cart$pars5 === void 0 ? void 0 : _DPServices$Cart$pars5.faults;
                haveErrorDescription = faults && faults[0] && faults[0].faultDescription;

                if (!haveErrorDescription) {
                  _context44.next = 19;
                  break;
                }

                throw new Error(haveErrorDescription);

              case 19:
                throw Errors.UPDATE_LAST_NAME_FAILED;

              case 20:
                runInAction(function () {
                  _this25.userProfile = response;
                });
                this.cacheUserProfile(response);
                profileModel.resetValues();
                _context44.next = 29;
                break;

              case 25:
                _context44.prev = 25;
                _context44.t0 = _context44["catch"](0);
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context44.t0.message, null, {
                  okBtnText: "Home",
                  okBtnOnClick: function okBtnOnClick() {
                    _this25.rootStore.reloadApp();
                  }
                });
                throw _context44.t0;

              case 29:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, this, [[0, 25]]);
      }));

      function updateUserLastName() {
        return _updateUserLastName.apply(this, arguments);
      }

      return updateUserLastName;
    }()
  }, {
    key: "updateUserPassword",
    value: function () {
      var _updateUserPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45() {
        var _this26 = this;

        var profileModel, userConfirmPassword, userNewPassword, userCurrentPassword, payload, _yield$handle27, _yield$handle28, err, response, _DPServices$Cart$pars6, errObj, faults, haveErrorDescription, profile;

        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                _context45.prev = 0;
                profileModel = this.userProfileModel;
                userConfirmPassword = profileModel.userConfirmPassword, userNewPassword = profileModel.userNewPassword, userCurrentPassword = profileModel.userCurrentPassword;
                payload = {
                  confirmpassword: userConfirmPassword,
                  password: userNewPassword,
                  oldPassword: userCurrentPassword
                };
                _context45.next = 6;
                return handle(DPServices.User.updatePassword(payload));

              case 6:
                _yield$handle27 = _context45.sent;
                _yield$handle28 = _slicedToArray(_yield$handle27, 2);
                err = _yield$handle28[0];
                response = _yield$handle28[1];

                if (!err) {
                  _context45.next = 21;
                  break;
                }

                errObj = err;
                faults = (_DPServices$Cart$pars6 = DPServices.Cart.parseErrors(errObj)) === null || _DPServices$Cart$pars6 === void 0 ? void 0 : _DPServices$Cart$pars6.faults;
                haveErrorDescription = faults && faults[0] && faults[0].faultDescription;

                if (!haveErrorDescription) {
                  _context45.next = 18;
                  break;
                }

                throw new Error(haveErrorDescription);

              case 18:
                throw Errors.UPDATE_PASSWORD_FAILED;

              case 19:
                _context45.next = 24;
                break;

              case 21:
                profile = response;
                _context45.next = 24;
                return this.saveCredentials(profile.login, payload.confirmpassword, null);

              case 24:
                runInAction(function () {
                  _this26.userProfile = response;
                });
                this.cacheUserProfile(response);
                profileModel.resetValues();
                _context45.next = 33;
                break;

              case 29:
                _context45.prev = 29;
                _context45.t0 = _context45["catch"](0);
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context45.t0.message, null, {
                  okBtnText: "Home",
                  okBtnOnClick: function okBtnOnClick() {
                    _this26.rootStore.reloadApp();
                  }
                });
                throw _context45.t0;

              case 33:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45, this, [[0, 29]]);
      }));

      function updateUserPassword() {
        return _updateUserPassword.apply(this, arguments);
      }

      return updateUserPassword;
    }()
  }, {
    key: "updateUserDob",
    value: function () {
      var _updateUserDob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46() {
        var _this27 = this;

        var _this$userProfile13, userId, profileModel, userDobDay, userDobMonth, userDobYear, payload, _yield$handle29, _yield$handle30, err, response, _DPServices$Cart$pars7, errObj, faults, haveErrorDescription;

        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                _context46.prev = 0;
                userId = (_this$userProfile13 = this.userProfile) === null || _this$userProfile13 === void 0 ? void 0 : _this$userProfile13.userId;
                profileModel = this.userProfileModel;
                userDobDay = profileModel.userDobDay, userDobMonth = profileModel.userDobMonth, userDobYear = profileModel.userDobYear;
                payload = {
                  dobYear: userDobYear,
                  dobMonth: userDobMonth,
                  dobDay: userDobDay
                };
                _context46.next = 7;
                return handle(DPServices.User.updateDob(payload, userId));

              case 7:
                _yield$handle29 = _context46.sent;
                _yield$handle30 = _slicedToArray(_yield$handle29, 2);
                err = _yield$handle30[0];
                response = _yield$handle30[1];

                if (!err) {
                  _context46.next = 20;
                  break;
                }

                errObj = err;
                faults = (_DPServices$Cart$pars7 = DPServices.Cart.parseErrors(errObj)) === null || _DPServices$Cart$pars7 === void 0 ? void 0 : _DPServices$Cart$pars7.faults;
                haveErrorDescription = faults && faults[0] && faults[0].faultDescription;

                if (!haveErrorDescription) {
                  _context46.next = 19;
                  break;
                }

                throw new Error(haveErrorDescription);

              case 19:
                throw Errors.UPDATE_DOB_FAILED;

              case 20:
                runInAction(function () {
                  _this27.userProfile = response;
                });
                this.cacheUserProfile(response);
                profileModel.resetValues();
                _context46.next = 29;
                break;

              case 25:
                _context46.prev = 25;
                _context46.t0 = _context46["catch"](0);
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context46.t0.message, null, {
                  okBtnText: "Home",
                  okBtnOnClick: function okBtnOnClick() {
                    _this27.rootStore.reloadApp();
                  }
                });
                throw _context46.t0;

              case 29:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, this, [[0, 25]]);
      }));

      function updateUserDob() {
        return _updateUserDob.apply(this, arguments);
      }

      return updateUserDob;
    }()
  }, {
    key: "resetPasswordRequest",
    value: function () {
      var _resetPasswordRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47() {
        var _this$userProfileMode7;

        var payload, _yield$handle31, _yield$handle32, error, response, errorDescription;

        return _regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                payload = {
                  login: (_this$userProfileMode7 = this.userProfileModel) === null || _this$userProfileMode7 === void 0 ? void 0 : _this$userProfileMode7.resetPasswordEmailAddress
                };
                _context47.next = 3;
                return handle(DPServices.User.resetPasswordRequest(payload));

              case 3:
                _yield$handle31 = _context47.sent;
                _yield$handle32 = _slicedToArray(_yield$handle31, 2);
                error = _yield$handle32[0];
                response = _yield$handle32[1];

                if (!error) {
                  _context47.next = 10;
                  break;
                }

                errorDescription = DPServices.Common.checkAndGetErrorDescription(error) || Errors.RESET_PASSWORD_FAILED;
                throw errorDescription;

              case 10:
                return _context47.abrupt("return", response);

              case 11:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, this);
      }));

      function resetPasswordRequest() {
        return _resetPasswordRequest.apply(this, arguments);
      }

      return resetPasswordRequest;
    }()
  }, {
    key: "resetPassword",
    value: function () {
      var _resetPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(uid, fptoken) {
        var _this$userProfileMode8, _this$userProfileMode9, _this$userProfileMode10, payload, _yield$handle33, _yield$handle34, err, response, _DPServices$Cart$pars8, errObj, faults, haveErrorDescription, userProfile;

        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                _context48.prev = 0;
                payload = {
                  login: (_this$userProfileMode8 = this.userProfileModel) === null || _this$userProfileMode8 === void 0 ? void 0 : _this$userProfileMode8.resetPasswordEmailAddress,
                  password: (_this$userProfileMode9 = this.userProfileModel) === null || _this$userProfileMode9 === void 0 ? void 0 : _this$userProfileMode9.resetPasswordNewPassword,
                  confirmPassword: (_this$userProfileMode10 = this.userProfileModel) === null || _this$userProfileMode10 === void 0 ? void 0 : _this$userProfileMode10.resetPasswordConfirmNewPassword,
                  // below values will come from deep link
                  uid: uid,
                  fptoken: fptoken
                };
                _context48.next = 4;
                return handle(DPServices.User.resetPassword(payload));

              case 4:
                _yield$handle33 = _context48.sent;
                _yield$handle34 = _slicedToArray(_yield$handle33, 2);
                err = _yield$handle34[0];
                response = _yield$handle34[1];

                if (!err) {
                  _context48.next = 19;
                  break;
                }

                errObj = err;
                faults = (_DPServices$Cart$pars8 = DPServices.Cart.parseErrors(errObj)) === null || _DPServices$Cart$pars8 === void 0 ? void 0 : _DPServices$Cart$pars8.faults;
                haveErrorDescription = faults && faults[0] && faults[0].faultDescription;

                if (!haveErrorDescription) {
                  _context48.next = 16;
                  break;
                }

                throw new Error(haveErrorDescription);

              case 16:
                throw Errors.RESET_PASSWORD_FAILED;

              case 17:
                _context48.next = 26;
                break;

              case 19:
                _context48.next = 21;
                return this.saveCredentials(payload.login, payload.password, null);

              case 21:
                _context48.next = 23;
                return this.getCurrentUserProfile();

              case 23:
                userProfile = _context48.sent;
                _context48.next = 26;
                return this.postLogin(userProfile);

              case 26:
                _context48.next = 32;
                break;

              case 28:
                _context48.prev = 28;
                _context48.t0 = _context48["catch"](0);
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context48.t0.message);
                throw _context48.t0;

              case 32:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this, [[0, 28]]);
      }));

      function resetPassword(_x21, _x22) {
        return _resetPassword.apply(this, arguments);
      }

      return resetPassword;
    }()
  }, {
    key: "updateFavoriteLocation",
    value: function () {
      var _updateFavoriteLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(restaurantId, favouriteLocationAction) {
        var _this28 = this,
            _this$rootStore2,
            _this$rootStore2$rest;

        var _this$userProfile14, userId, login, payload, _yield$handle35, _yield$handle36, error, response, errorDescription;

        return _regeneratorRuntime.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                _this$userProfile14 = this.userProfile, userId = _this$userProfile14.userId, login = _this$userProfile14.login;
                payload = {
                  email: login,
                  restaurantIdentifier: restaurantId,
                  favouriteLocationAction: favouriteLocationAction
                };
                _context49.next = 4;
                return handle(DPServices.User.updateFavoriteLocation(payload, userId));

              case 4:
                _yield$handle35 = _context49.sent;
                _yield$handle36 = _slicedToArray(_yield$handle35, 2);
                error = _yield$handle36[0];
                response = _yield$handle36[1];

                if (!error) {
                  _context49.next = 12;
                  break;
                }

                errorDescription = DPServices.Common.checkAndGetErrorDescription(error) || Errors.UPDATE_FAVORITE_LOCATION;
                this.rootStore.appMessages.showError(favouriteLocationAction === "remove" ? ERROR_STRINGS.REMOVE_FAVORITE_LOCATION : ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, errorDescription.message);
                throw errorDescription;

              case 12:
                runInAction(function () {
                  _this28.userProfile = response;
                });
                this.cacheUserProfile(response);
                (_this$rootStore2 = this.rootStore) === null || _this$rootStore2 === void 0 ? void 0 : (_this$rootStore2$rest = _this$rootStore2.restaurant) === null || _this$rootStore2$rest === void 0 ? void 0 : _this$rootStore2$rest.getUserLocations();

              case 15:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));

      function updateFavoriteLocation(_x23, _x24) {
        return _updateFavoriteLocation.apply(this, arguments);
      }

      return updateFavoriteLocation;
    }()
  }, {
    key: "getSettingsData",
    value: function () {
      var _getSettingsData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(settingType) {
        return _regeneratorRuntime.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                return _context50.abrupt("return", DPServices.User.getSettings(settingType));

              case 1:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50);
      }));

      function getSettingsData(_x25) {
        return _getSettingsData.apply(this, arguments);
      }

      return getSettingsData;
    }()
  }, {
    key: "isDeviceVersionGreater",
    value: function isDeviceVersionGreater(myVersion, minVersionReq) {
      var s1 = myVersion === null || myVersion === void 0 ? void 0 : myVersion.split(".");
      var s2 = minVersionReq === null || minVersionReq === void 0 ? void 0 : minVersionReq.split(".");
      var maxLength = Math.max(s1 === null || s1 === void 0 ? void 0 : s1.length, s2 === null || s2 === void 0 ? void 0 : s2.length);

      if (maxLength) {
        for (var i = 0; i < maxLength; i++) {
          var a = i < (s1 === null || s1 === void 0 ? void 0 : s1.length) ? toInteger(s1[i]) : 0;
          var b = i < (s2 === null || s2 === void 0 ? void 0 : s2.length) ? toInteger(s2[i]) : 0;

          if (!isEqual(a, b)) {
            var compare = gt(a, b);
            return compare;
          }
        }

        return true;
      } else return false;
    }
  }, {
    key: "forceUpdateNeeded",
    value: function forceUpdateNeeded(currentAppVersion) {
      var _this$rootStore3, _this$rootStore3$comm, _this$rootStore3$comm2, _this$rootStore4, _this$rootStore4$plat, _this$rootStore5, _this$rootStore5$plat, _forceVersions$split$; // below line just to avoid force app update in Dev Environment


      if (__DEV__) {
        return false;
      }

      var _ref = ((_this$rootStore3 = this.rootStore) === null || _this$rootStore3 === void 0 ? void 0 : (_this$rootStore3$comm = _this$rootStore3.common) === null || _this$rootStore3$comm === void 0 ? void 0 : (_this$rootStore3$comm2 = _this$rootStore3$comm.appAttributes) === null || _this$rootStore3$comm2 === void 0 ? void 0 : _this$rootStore3$comm2.mobileApp) || {},
          ios = _ref.ios,
          android = _ref.android;

      var forceVersions = (this === null || this === void 0 ? void 0 : (_this$rootStore4 = this.rootStore) === null || _this$rootStore4 === void 0 ? void 0 : (_this$rootStore4$plat = _this$rootStore4.platformUtil) === null || _this$rootStore4$plat === void 0 ? void 0 : _this$rootStore4$plat.platformDetails().os) === "iOS" ? ios === null || ios === void 0 ? void 0 : ios.forceVersions : android === null || android === void 0 ? void 0 : android.forceVersions;
      var minVersion = (this === null || this === void 0 ? void 0 : (_this$rootStore5 = this.rootStore) === null || _this$rootStore5 === void 0 ? void 0 : (_this$rootStore5$plat = _this$rootStore5.platformUtil) === null || _this$rootStore5$plat === void 0 ? void 0 : _this$rootStore5$plat.platformDetails().os) === "iOS" ? ios === null || ios === void 0 ? void 0 : ios.minVersion : android === null || android === void 0 ? void 0 : android.minVersion;
      var forceUpdateNeeded = (_forceVersions$split$ = forceVersions === null || forceVersions === void 0 ? void 0 : forceVersions.split(",").map(function (forceVersion) {
        return forceVersion === currentAppVersion;
      }).includes(true)) !== null && _forceVersions$split$ !== void 0 ? _forceVersions$split$ : false;
      var isMinVersionGreater = minVersion ? !this.isDeviceVersionGreater(currentAppVersion, minVersion) : false;

      if (forceUpdateNeeded || isMinVersionGreater) {
        return true;
      }

      return false;
    }
  }, {
    key: "postLoginHelper",
    value: function () {
      var _postLoginHelper = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51() {
        var updatedUserProfile;
        return _regeneratorRuntime.wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                _context51.next = 2;
                return this.getCurrentUserProfile();

              case 2:
                updatedUserProfile = _context51.sent;
                _context51.next = 5;
                return this.postLogin(updatedUserProfile);

              case 5:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, this);
      }));

      function postLoginHelper() {
        return _postLoginHelper.apply(this, arguments);
      }

      return postLoginHelper;
    }()
  }, {
    key: "fetchAndUpdateUserProfile",
    value: function () {
      var _fetchAndUpdateUserProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52() {
        var _this29 = this;

        var _yield$handle37, _yield$handle38, error, updatedUserProfile;

        return _regeneratorRuntime.wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                _context52.next = 2;
                return handle(this.getCurrentUserProfile());

              case 2:
                _yield$handle37 = _context52.sent;
                _yield$handle38 = _slicedToArray(_yield$handle37, 2);
                error = _yield$handle38[0];
                updatedUserProfile = _yield$handle38[1];

                if (error) {// do nothing
                } else {
                  runInAction(function () {
                    _this29.rootStore.user.userProfile = updatedUserProfile;
                  });
                }

              case 7:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52, this);
      }));

      function fetchAndUpdateUserProfile() {
        return _fetchAndUpdateUserProfile.apply(this, arguments);
      }

      return fetchAndUpdateUserProfile;
    }()
  }, {
    key: "getLocationServiceStatus",
    value: function getLocationServiceStatus() {
      if (this.foreGroundLocationPermissions.granted && this.backGroundLocationPermissions.granted) {
        return LocationServiceStatus.ALWAYS;
      } else if (this.foreGroundLocationPermissions.granted) {
        return LocationServiceStatus.WHILE_USING_THE_APP;
      } else if (this.foreGroundLocationPermissions.canAskAgain || this.backGroundLocationPermissions.canAskAgain) {
        return LocationServiceStatus.ASK_NEXT_TIME;
      } else {
        return LocationServiceStatus.NEVER;
      }
    }
  }, {
    key: "showHomeScreenAlert",
    get: function get() {
      return this._showHomeScreenAlert;
    },
    set: function set(val) {
      var _this30 = this;

      runInAction(function () {
        _this30._showHomeScreenAlert = val;
      });
    }
  }, {
    key: "isHomeScreenAlertClosed",
    get: function get() {
      return this._isHomeScreenAlertClosed;
    },
    set: function set(val) {
      var _this31 = this;

      runInAction(function () {
        _this31._isHomeScreenAlertClosed = val;
      });
    }
  }, {
    key: "promptForLocationPermissions",
    get: function get() {
      if (this.foregroundLocationPermissionGranted || !this._promptForLocationPermissions) {
        return false;
      } else {
        return this._promptForLocationPermissions;
      }
    },
    set: function set(val) {
      var _this32 = this;

      runInAction(function () {
        _this32._promptForLocationPermissions = val;
      });
    }
  }, {
    key: "promptForPhotoLibraryPermissions",
    get: function get() {
      if (this.photoLibraryPermissionGranted || !this._promptForPhotoLibraryPermissions) {
        return false;
      } else {
        return this._promptForPhotoLibraryPermissions;
      }
    },
    set: function set(val) {
      var _this33 = this;

      runInAction(function () {
        _this33._promptForPhotoLibraryPermissions = val;
      });
    }
  }, {
    key: "isMobilePayAvailable",
    get: function get() {
      var appAttributes = this.rootStore.common.appAttributes;
      var isWebMobilePayLoginEnforced = appAttributes.isWebMobilePayLoginEnforced;
      var isMobilePayForVIPGuestsEnabled = appAttributes.isMobilePayForVIPGuestsEnabled;
      var userProfile = this.userProfile;

      if (isMobilePayForVIPGuestsEnabled) {
        return userProfile && !!userProfile.isMobilePayEnabled;
      } else {
        if (isWebMobilePayLoginEnforced) {
          return !!userProfile;
        } else {
          return true;
        }
      }
    }
  }, {
    key: "isLoggedIn",
    get: function get() {
      var _this$sessionDetails, _this$sessionDetails$, _this$sessionDetails$2;

      return this.sessionDetails ? !((_this$sessionDetails = this.sessionDetails) !== null && _this$sessionDetails !== void 0 && (_this$sessionDetails$ = _this$sessionDetails.successResponse) !== null && _this$sessionDetails$ !== void 0 && (_this$sessionDetails$2 = _this$sessionDetails$.profile) !== null && _this$sessionDetails$2 !== void 0 && _this$sessionDetails$2["transient"]) : false;
    }
  }, {
    key: "userPicture",
    get: function get() {
      var _this$loginModal2, _this$loginModal2$use, _this$userProfile15, _this$loginModal4, _this$loginModal4$soc;

      if (!this.isLoggedIn) {
        return null;
      }

      if ((_this$loginModal2 = this.loginModal) !== null && _this$loginModal2 !== void 0 && (_this$loginModal2$use = _this$loginModal2.userSelectedProfilePicture) !== null && _this$loginModal2$use !== void 0 && _this$loginModal2$use.url) {
        var _this$loginModal3;

        return (_this$loginModal3 = this.loginModal) === null || _this$loginModal3 === void 0 ? void 0 : _this$loginModal3.userSelectedProfilePicture;
      } else if (((_this$userProfile15 = this.userProfile) === null || _this$userProfile15 === void 0 ? void 0 : _this$userProfile15.login) === ((_this$loginModal4 = this.loginModal) === null || _this$loginModal4 === void 0 ? void 0 : (_this$loginModal4$soc = _this$loginModal4.socialProfile) === null || _this$loginModal4$soc === void 0 ? void 0 : _this$loginModal4$soc.email)) {
        var _this$loginModal5, _this$loginModal5$soc;

        return (_this$loginModal5 = this.loginModal) === null || _this$loginModal5 === void 0 ? void 0 : (_this$loginModal5$soc = _this$loginModal5.socialProfile) === null || _this$loginModal5$soc === void 0 ? void 0 : _this$loginModal5$soc.picture;
      } else {
        return null;
      }
    }
  }, {
    key: "foregroundLocationPermissionGranted",
    get: function get() {
      if (this.foreGroundLocationPermissions) {
        return this.foreGroundLocationPermissions.granted;
      } else {
        return false;
      }
    }
  }, {
    key: "backgroundLocationPermissionGranted",
    get: function get() {
      if (this.backGroundLocationPermissions) {
        return this.backGroundLocationPermissions.granted;
      } else {
        return false;
      }
    }
  }, {
    key: "pushNotificationPermissionGranted",
    get: function get() {
      if (this.pushNotificationAuthorizationStatus) {
        return this.pushNotificationAuthorizationStatus === PushNotificationAuthorizationStatus.AUTHORIZED;
      } else {
        return false;
      }
    }
  }, {
    key: "photoLibraryPermissionGranted",
    get: function get() {
      if (this.photoLibraryPermissionStatus) {
        return this.photoLibraryPermissionStatus === CapabilityPermissionStatus.GRANTED;
      } else {
        return false;
      }
    }
  }, {
    key: "alertFromRestaurantDetails",
    get: function get() {
      var _this$rootStore6,
          _this$rootStore6$rest,
          _this$rootStore6$rest2,
          _this$rootStore7,
          _this$rootStore7$rest,
          _this$rootStore7$rest2,
          _this34 = this;

      var appSystemAlertMessage = (_this$rootStore6 = this.rootStore) === null || _this$rootStore6 === void 0 ? void 0 : (_this$rootStore6$rest = _this$rootStore6.restaurant) === null || _this$rootStore6$rest === void 0 ? void 0 : (_this$rootStore6$rest2 = _this$rootStore6$rest.detail) === null || _this$rootStore6$rest2 === void 0 ? void 0 : _this$rootStore6$rest2.appSystemAlertMessage;
      var appSystemAlertURL = (_this$rootStore7 = this.rootStore) === null || _this$rootStore7 === void 0 ? void 0 : (_this$rootStore7$rest = _this$rootStore7.restaurant) === null || _this$rootStore7$rest === void 0 ? void 0 : (_this$rootStore7$rest2 = _this$rootStore7$rest.detail) === null || _this$rootStore7$rest2 === void 0 ? void 0 : _this$rootStore7$rest2.appSystemAlertURL;

      if (appSystemAlertMessage) {
        runInAction(function () {
          _this34.showHomeScreenAlert = true;
        });
        var obj = {
          appSystemAlertMessage: appSystemAlertMessage,
          appSystemAlertURL: appSystemAlertURL
        };
        return obj;
      }

      return null;
    }
  }, {
    key: "alertFromAppInit",
    get: function get() {
      var _this$rootStore8,
          _this$rootStore8$comm,
          _this$rootStore8$comm2,
          _this$rootStore9,
          _this$rootStore9$comm,
          _this$rootStore9$comm2,
          _this35 = this;

      var appSystemAlertMessage = (_this$rootStore8 = this.rootStore) === null || _this$rootStore8 === void 0 ? void 0 : (_this$rootStore8$comm = _this$rootStore8.common) === null || _this$rootStore8$comm === void 0 ? void 0 : (_this$rootStore8$comm2 = _this$rootStore8$comm.appAttributes) === null || _this$rootStore8$comm2 === void 0 ? void 0 : _this$rootStore8$comm2.appSystemAlertMessage;
      var appSystemAlertURL = (_this$rootStore9 = this.rootStore) === null || _this$rootStore9 === void 0 ? void 0 : (_this$rootStore9$comm = _this$rootStore9.common) === null || _this$rootStore9$comm === void 0 ? void 0 : (_this$rootStore9$comm2 = _this$rootStore9$comm.appAttributes) === null || _this$rootStore9$comm2 === void 0 ? void 0 : _this$rootStore9$comm2.appSystemAlertURL;

      if (appSystemAlertMessage) {
        runInAction(function () {
          _this35.showHomeScreenAlert = true;
        });
        var obj = {
          appSystemAlertMessage: appSystemAlertMessage,
          appSystemAlertURL: appSystemAlertURL
        };
        return obj;
      }

      return null;
    }
  }, {
    key: "restaurantIdToBeSavedInUserProfile",
    get: function get() {
      return this._restaurantIdToBeSavedInUserProfile;
    },
    set: function set(_restaurantIdToBeSavedInUserProfile) {
      var _this36 = this;

      runInAction(function () {
        _this36._restaurantIdToBeSavedInUserProfile = _restaurantIdToBeSavedInUserProfile;
      });
    }
  }, {
    key: "isOrderSummaryOpen",
    get: function get() {
      return this._isOrderSummaryOpen;
    },
    set: function set(value) {
      var _this37 = this;

      runInAction(function () {
        _this37._isOrderSummaryOpen = value;
      });
    }
  }]);

  return User;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userProfile", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "profileResponse", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "savedCreds", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isAuthenticated", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "foreGroundLocationPermissions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "backGroundLocationPermissions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "deviceAuth", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "currentUserLocation", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_promptForLocationPermissions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "pushNotificationAuthorizationStatus", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "photoLibraryPermissionStatus", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_promptForPhotoLibraryPermissions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_showHomeScreenAlert", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_restaurantIdToBeSavedInUserProfile", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "_isHomeScreenAlertClosed", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "_isOrderSummaryOpen", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "showHomeScreenAlert", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showHomeScreenAlert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isHomeScreenAlertClosed", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isHomeScreenAlertClosed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "promptForLocationPermissions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "promptForLocationPermissions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "promptForPhotoLibraryPermissions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "promptForPhotoLibraryPermissions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dissmissPromptForLocationPermissions", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dissmissPromptForLocationPermissions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dismissPromptForPhotoLibraryPermissions", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dismissPromptForPhotoLibraryPermissions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reset", [action], Object.getOwnPropertyDescriptor(_class.prototype, "reset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isMobilePayAvailable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMobilePayAvailable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLoggedIn", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLoggedIn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userPicture", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userPicture"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "foregroundLocationPermissionGranted", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "foregroundLocationPermissionGranted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "backgroundLocationPermissionGranted", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "backgroundLocationPermissionGranted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pushNotificationPermissionGranted", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "pushNotificationPermissionGranted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "photoLibraryPermissionGranted", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "photoLibraryPermissionGranted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "whenAppActive", [action], Object.getOwnPropertyDescriptor(_class.prototype, "whenAppActive"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "alertFromRestaurantDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "alertFromRestaurantDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "alertFromAppInit", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "alertFromAppInit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantIdToBeSavedInUserProfile", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantIdToBeSavedInUserProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOrderSummaryOpen", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOrderSummaryOpen"), _class.prototype)), _class);
export { User as default };